<div class="grid">
  <div class="col-12 col-12 md:col-12">
    <p-accordion id="accordion" [multiple]="false" (onOpen)="abrirAcordeon($event.index)">
      <p-accordionTab header="{{ titulo }}" [selected]="tabSeleccionado === 'DATGEN'">
        <app-flujo-venta-tab-view
          [tabView]="tabView"
          [listaSecuencias]="listaSecuencias"
          [listaVinculaciones]="listaVinculaciones"
          [listaTiposPersonas]="listaTiposPersonas"
          [lisPasos]="lisPasos"
          [secFija]="false"
          [showControlesTable]="false"
          [esAcordeon]="true"
          [HabilitarindicadorVinculacionPorPerfil]=true
          (goNextAccordion)="abrirAcordeon(1)">
        </app-flujo-venta-tab-view>
      </p-accordionTab>

      <p-accordionTab header="{{ 'FLUJOVENTAAUTORIZACIONES.LBL_REINTENTOS' | translate }}" [selected]="tabSeleccionado === 'REINT'"
                      [disabled]="!tabView.flujoVenta?.idFlujoVentaPaso">
        <app-flujo-venta-reintento [fluVentaPaso]="tabView.flujoVenta"
                                   [lisEstados]="lisEstados" [tipo]="'FUNCON'" *ngIf="tabView.flujoVenta?.idFlujoVentaPaso"
                                   [lisControlesTodos]="tabView.controles"></app-flujo-venta-reintento>
      </p-accordionTab>

      <p-accordionTab header="{{ 'FLUJOVENTAAUTORIZACIONES.LBL_PLANTILLAS' | translate }}" [selected]="tabSeleccionado === 'PLANT'"
                      [disabled]="!tabView.flujoVenta?.idFlujoVentaPaso">
        <app-flujo-venta-plantilla
          [fluVentaPaso]="tabView.flujoVenta"
          [lisFases]="lisFases"
          [lisPlantilla]="lisPlantilla"
          [lisAutorizaciones]="lisAutorizaciones"
          [listasTiposProductosBancarios]="listasTiposProductosBancarios"
          *ngIf="tabView.flujoVenta?.idFlujoVentaPaso"
        ></app-flujo-venta-plantilla>
      </p-accordionTab>

      <!-- TAB Restricciones Perfil por Vinculación -->
      <p-accordionTab header="{{ 'FLUJOVENTARESTRICCIONESPERFILXVINCULACION.LBL_FLUJOVENTARESTRICCIONESPERFILXVINCULACION' | translate }}"
                      [selected]="tabSeleccionado === 'RESPERXVIN'"
                      [disabled]="!tabView.flujoVenta?.idFlujoVentaPaso"
                      *ngIf="tabView.flujoVenta?.indicadorVinculacionPerfil"
                      >
                      <app-fv-restricciones-perfil-x-vinculacion [tabView]="tabView"></app-fv-restricciones-perfil-x-vinculacion>
      </p-accordionTab>
    </p-accordion>
  </div>
</div>

